import React, { useState } from "react";
import { Card, CardHeader, Avatar, Typography, Grid, Collapse, CardContent, CardActionArea } from "@material-ui/core";
import moment from "moment";
import { Membership } from "api/memberships";
import { ActivityItem } from "api/admin/activities";
import i18n from "../i18n";
import generateTextForActivityItem from "./generate";

// prop types
interface ActivityCardProps {
    activity: ActivityItem,
    memberships: Membership[],
}

// admin activity log item
const ActivityCard = ({ activity, memberships }: ActivityCardProps) => {
    // ui state
    const [expanded, setExpanded] = useState(false);

    // get club name belonging to activity
    const getClubName = (a: ActivityItem) => memberships.find((m) => m.club.id === a.booking.court.clubId)?.club.shortName;

    // render details row
    const renderDetailsRow = (label: string, value: string) => (
        <>
            <Grid item xs={4}>
                <Typography>{label}</Typography>
            </Grid>
            <Grid item xs={8}>
                <Typography>{value}</Typography>
            </Grid>
        </>
    );

    // render
    return (
        <Card>
            <CardActionArea onClick={() => setExpanded(!expanded)}>
                <CardHeader
                    avatar={<Avatar src={activity.user ? activity.user.profilePictureUrl : "images/playsports_logo.svg"} />}
                    title={generateTextForActivityItem(activity)}
                    subheader={(
                        <Typography color="textSecondary" variant="body2">
                            {moment(activity.createdAt).format(`DD.MM.YYYY [${i18n.at}] HH:mm`)}
                            {" \u2022 "}
                            {getClubName(activity)}
                            {" \u2022 "}
                            {activity.booking.court.courtName}
                        </Typography>
                    )}
                />
                <Collapse in={expanded}>
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>{i18n.bookingDetails}</Typography>
                        <Grid container spacing={1}>
                            {renderDetailsRow(i18n.type, i18n.bookingTypes[activity.booking.bookingType])}
                            {renderDetailsRow(i18n.startTime, moment(activity.booking.startDate).format("DD.MM.YYYY HH:mm"))}
                            {renderDetailsRow(i18n.endTime, moment(activity.booking.endDate).format("DD.MM.YYYY HH:mm"))}
                            {activity.booking.description && renderDetailsRow(i18n.description, activity.booking.description)}
                        </Grid>
                    </CardContent>
                </Collapse>
            </CardActionArea>
        </Card>
    );
};

export default ActivityCard;
